import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnacademyComponent } from './simple-icons-unacademy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnacademyComponent ],
    exports:      [ SimpleIconsUnacademyComponent ],
    bootstrap:    []
})
export class SimpleIconsUnacademyModule {}
